export const WORKING_ID = 'working-polygon-drawing'
